<!-- @todo - is this being used? -->
<template>
  <v-card>
    <v-card-title primary-title class="headline blue-grey lighten-5">{{title}}</v-card-title>
    <v-divider></v-divider>
    <display-files
      :queries="queries"
      :hasActionColumn="hasActionColumn"
      @confirm="(id) => $emit('confirm', id)"
      @queryToDeleteId="(q) => this.queryToDelete = q"
    ></display-files>
    <v-divider></v-divider>
    <v-card-actions class="blue-grey lighten-5">
      <v-btn @click.stop="$emit('close')">
        Cancel
      </v-btn>
    </v-card-actions>
    <confirm-delete-modal
      :query="queryToDelete"
      @close="queryToDelete=null"
      @completed="handledDeleteCompleted"
      @error="handleDeleteError"
    ></confirm-delete-modal>
  </v-card>
</template>

<script>
import Sugar from 'sugar'
import ConfirmDeleteModal from './ConfirmDeleteModal'
import DisplayFiles from '../parts/DisplayFiles'

export default {
  name: 'query-choose-modal',
  components: {
    Sugar,
    ConfirmDeleteModal,
    DisplayFiles
  },
  props: ['queries', 'title', 'defaultSearchName', 'hasActionColumn'],
  data () {
    return {
      showDeleteConfirmationModal: false,
      queryToDelete: null,
      currentSortField: 'name',
      currentSortAscending: true,
      sortedQueries: [...this.queries]
    }
  },
  watch: {
    queries: function (val, oldVal) {
      this.prepareData()
      this.sortQueries()
    }
  },
  created () {
    Sugar.extend()
  },
  mounted () {
    this.prepareData()
  },
  methods: {
    prepareData () {
      this.sortedQueries = [...this.queries]
      this.sortedQueries.map(x => {
        x.sugarUpdatedAt = Sugar.Date.create(x.updatedAt)
      })
    },
    formatDate (q) {
      if (q && q.updatedAt) {
        return Sugar.Date.format(q.sugarUpdatedAt, '%d %h %y - %X')
      } else {
        return ''
      }
    },
    formatDateRelative (q) {
      if (q && q.updatedAt) {
        return Sugar.Date.relative(q.sugarUpdatedAt)
      } else {
        return ''
      }
    },
    formulateIcon (targetField) {
      if (targetField === this.currentSortField) {
        return this.currentSortAscending ? 'arrow_drop_down' : 'arrow_drop_up'
      } else {
        return ''
      }
    },
    handleDeleteClick (q) {
      this.queryToDelete = q
    },
    handledDeleteCompleted () {
      this.queryToDelete = null
      this.$emit('deleteCompleted')
    },
    handleDeleteError (error) {
      this.$emit('error', error)
    },
    formulateSearchName: function (q) {
      return q && q.defaultSearchName
        ? q.defaultSearchName
        : this.defaultSearchName
    },
    sortQueries () {
      if (typeof this.queries === 'undefined' || this.queries === null || this.queries.length <= 1) {
        return
      }
      const f = this.currentSortField
      this.sortedQueries.sort((a, b) => {
        if (f === 'name') {
          return this.currentSortAscending
            ? a[f].localeCompare(b[f])
            : b[f].localeCompare(a[f])
        } else if (f === 'search') {
          return this.currentSortAscending
            ? this.formulateSearchName(a).localeCompare(this.formulateSearchName(b))
            : this.formulateSearchName(b).localeCompare(this.formulateSearchName(a))
        } else {
          if (a.sugarUpdatedAt.isBefore(b.sugarUpdatedAt)) {
            return this.currentSortAscending ? -1 : 1
          }
          if (a.sugarUpdatedAt.isAfter(b.sugarUpdatedAt)) {
            return this.currentSortAscending ? 1 : -1
          }
          return 0
        }
      })
    },
    handleSortClick (targetField) {
      if (targetField === this.currentSortField) {
        this.currentSortAscending = !this.currentSortAscending
      } else {
        this.currentSortField = targetField
        this.currentSortAscending = true
      }
      this.sortQueries()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.tds-alternate-rows:nth-child(even) {
  background-color: $grey-100;
}
.tds-list-row {
  cursor: pointer;
}
.sortableColumnHeading {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/QueryChooseModal.vue